export default __webpack_public_path__ + "static/media/washington_monument.0e734e30.png";